import type { ReactNode } from 'react';
import type { LucideIcon } from 'lucide-react';
import { Icon3D, type Icon3DName } from '@/components/Icon3D';
import { cn } from '@/lib/utils';

/**
 * Friendly empty / info state. Shows a 3D illustration (default "empty-state"); pass `icon` for a
 * line icon instead (e.g. inside dense tables).
 */
export function EmptyState({ icon: Icon, art = 'empty-state', title, children, action, className }: {
  icon?: LucideIcon; art?: Icon3DName; title: string; children?: ReactNode; action?: ReactNode; className?: string;
}) {
  return (
    <div className={cn('flex flex-col items-center justify-center gap-3 px-6 py-12 text-center', className)}>
      {Icon ? (
        <div className="flex size-14 items-center justify-center rounded-2xl bg-primary-soft text-primary">
          <Icon className="size-7" />
        </div>
      ) : (
        <Icon3D name={art} size={96} />
      )}
      <h3 className="text-lg font-semibold">{title}</h3>
      {children ? <div className="max-w-sm text-[15px] text-ink-2">{children}</div> : null}
      {action}
    </div>
  );
}
